var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFieldObsWeather = function SvgFieldObsWeather(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E131C2",
    d: "M19.944 1.795H4.056a2.276 2.276 0 0 0-2.27 2.27v15.888a2.276 2.276 0 0 0 2.27 2.27h15.888a2.276 2.276 0 0 0 2.27-2.27V4.065a2.276 2.276 0 0 0-2.27-2.27"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.988 15.154V4.564c0-.111.09-.2.2-.2h1.388c.11 0 .2.089.2.2v.157a.2.2 0 0 0 .106.177l4.065 2.172a.2.2 0 0 1 .013.344l-4.092 2.624a.2.2 0 0 0-.092.169v4.947c0 .11.09.2.2.2h2.73c.11 0 .2.09.2.2v3.9a.2.2 0 0 1-.2.2H7.952a.2.2 0 0 1-.2-.2v-3.9c0-.11.09-.2.2-.2h1.836a.2.2 0 0 0 .2-.2"
  })));
};
export default SvgFieldObsWeather;